import { ChatPanel, useChatContext } from '@webinex/chatify';
import styles from './ChatGlobalPanel.module.scss';
import { useDefaultChatCustomize } from '@app/chat/widgets/Chat';
import { PinChatButton } from './PinChatButton';
import { ExpandChatButton } from './ExpandChatButton';
import { useMobile } from '@app/ui';
import { closeGlobalChat } from '@app/chat/utils';

interface Props {
  id: string;
}

function CustomChatHeaderActions() {
  const { isMobile } = useMobile();
  const { id } = useChatContext();

  if (isMobile) {
    closeGlobalChat();
    return null;
  }

  return (
    <>
      <ExpandChatButton />
      <PinChatButton chatId={id} />
    </>
  );
}

export function ChatGlobalPanel(props: Props) {
  const { id } = props;
  const customize = {
    ...useDefaultChatCustomize(),
    ChatHeaderActions: CustomChatHeaderActions,
  };

  return (
    <div className={styles.content}>
      <ChatPanel customize={customize} id={id} />
    </div>
  );
}
